import { OPERATORS } from '../../constants';
import { BaseOperatorStrategy } from './base.operator-strategy';
import type { SelectionBlockerArgs, SelectionBlockerResult } from '../operator-strategy';

export class SatvuOperatorStrategy extends BaseOperatorStrategy {
  readonly operatorKey = OPERATORS.SATVU;

  protected computeBaseCost(sensorRow: any, latencyIndx: number): number | null {
    if (!sensorRow || !Array.isArray(sensorRow.latency)) return null;
    return Number(sensorRow.latency[latencyIndx]?.unitcost ?? 0);
  }

  getSelectionBlocker(args: SelectionBlockerArgs): SelectionBlockerResult | null {
    const selectedOption = args?.taskingContext?.selectedOption;
    if (selectedOption === 0 || selectedOption === 1 || selectedOption === 3) {
      const sensorRow = args?.sensorRow;
      const sensorName = [sensorRow?.displayName, sensorRow?.sensor]
        .filter(Boolean)
        .join(' ')
        .trim() || 'This sensor';
      return {
        code: 'SATVU_PERIOD_ONLY',
        message: `${sensorName} accepts only orders with a period collection at this time. Recurrent, Specific Date and Specific Day orders are a future capability. Please choose an alternative provider.`,
      };
    }

    if ((args?.taskingContext?.selectedAreaSqkm ?? 0) > 0) {
      const sensorRow = args?.sensorRow;
      const sensorName = [sensorRow?.displayName, sensorRow?.sensor]
        .filter(Boolean)
        .join(' ')
        .trim() || 'This sensor';
      return {
        code: 'SATVU_AOI_NOT_SUPPORTED',
        message: `${sensorName} accepts only POI (point of interest) orders. Please choose an alternative provider.`,
      };
    }

    return this.getMinDurationDaysBlocker(args);
  }

  private getMinDurationDaysBlocker(
    args: SelectionBlockerArgs,
  ): SelectionBlockerResult | null {
    if (!args.toiEndUtc) return null;
    const sensorRow = args?.sensorRow;
    const minDurationDays: number = sensorRow?.minDurationDays ?? 7;
    const durationDays = Math.floor(
      (args.toiEndUtc.getTime() - args.toiStartUtc.getTime()) / 86_400_000,
    );
    if (durationDays >= minDurationDays) return null;
    const sensorName = [sensorRow?.displayName, sensorRow?.sensor]
      .filter(Boolean)
      .join(' ')
      .trim() || 'This sensor';
    return {
      code: 'SATVU_TOI_MIN_DURATION_DAYS',
      message: `We are unable to accept this task as ${sensorName} requires time of interest (TOI) should be minimum ${minDurationDays} days. Please change your TOI or choose an alternative provider.`,
    };
  }
}
